export enum PersistentLocalStorageKeys {
  bbuPersistentData = 'bbuPersistentData',
  bbuPersistentUserStatus = 'bbuPersistentUserStatus',
}

export enum PersistentSessionStorageKeys {
  integrationAuthFlowAppId = 'integrationAuthFlowAppId',
  integrationAuthFlowCredentials = 'integrationAuthFlowCredentials',
}
